var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterXSeeklogocom4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.914,
    height: 18.914,
    viewBox: "0 0 18.914 18.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter-x-seeklogo.com-4",
    transform: "translate(-352.45 -128.77)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_398",
    "data-name": "Ellipse 398",
    cx: 8.957,
    cy: 8.957,
    r: 8.957,
    transform: "translate(352.95 129.27)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(356.363 133.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    d: "M483.967,356.79l4.281,5.725-4.308,4.654h.97l3.772-4.075,3.048,4.075h3.3l-4.522-6.046,4.01-4.332h-.97l-3.474,3.753-2.807-3.753Zm1.426.714h1.516l6.694,8.95h-1.516Z",
    transform: "translate(-483.94 -356.79)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterXSeeklogocom4);
export default __webpack_public_path__ + "static/media/twitter-x-seeklogo.com-4.fb56e08c1ed1697df1a4f9e6b1093785.svg";
export { ForwardRef as ReactComponent };